import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'

export class FlowChartNextStepBuilder {
  private nextStep: FlowChartNextStep

  constructor(id: string) {
    this.nextStep = { id, disabled: false }
  }

  withLabel(label: string): FlowChartNextStepBuilder {
    this.nextStep.label = label
    return this
  }

  withColor(color: string): FlowChartNextStepBuilder {
    this.nextStep.color = color
    return this
  }

  withTooltip(tooltip: string): FlowChartNextStepBuilder {
    this.nextStep.tooltip = tooltip
    return this
  }

  withDisabled(disabled: boolean): FlowChartNextStepBuilder {
    this.nextStep.disabled = disabled
    return this
  }

  build(): FlowChartNextStep {
    return this.nextStep
  }
}
